import react from "react";
import VFBr_1 from "../assets/VFBr_1.png";
import VFBr_2 from "../assets/VFBr_2.png";
import VFBr_3 from "../assets/VFBr_3.png";
import VFBr_4 from "../assets/VFBr_4.png";
import VFBr_5 from "../assets/VFBr_5.png";
import VFBr_6 from "../assets/VFBr_6.png";

export default function VFBr_FeaturesSection() {
  return (
    <div className="w-full bg-black py-20   md:py-16 sm:px-8 md:px-6 lg:px-8 xl:px-20 px-24">
      {/* GRID CONTAINER */}
      <div className=" gap-y-12 mx-auto grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 grid-cols-3  ">
        {/* CARD 1 */}
{/* CARD 1 */}
<div className="sm:border-b sm:text-left sm:border-r-0 md:border-r lg:border-r xl:border-r border-r border-[#2B2E33] p-8 xl:p-6 lg:p-6 md:p-5 sm:p-0">
  <div className="mb-6 flex sm:justify-center">
    <img src={VFBr_1} alt="Feature Icon 1" className="w-12 h-12 lg:w-10 lg:h-10 sm:w-8 sm:h-8" />
  </div>
  <div className="mb-4">
    <h3 className="font-[Norwester] font-[400] text-white text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] sm:text-[15px] mb-4 uppercase leading-tight">
      Turn Fans Into Active Participants
    </h3>
  </div>
  <div>
    <p className="font-[Inter] text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] leading-relaxed sm:mb-3">
      Marketing works best when audiences do not just watch, but take
      part. Vupop helps brands invite fans to share their view, their
      experience and their connection to your product.
      <br />
      Whether during a major sports tournament, a product launch, a
      seasonal campaign or a brand moment, fans can capture and share
      authentic content that strengthens your message.
      <br />
      Fan participation makes campaigns more human and more memorable.
    </p>
  </div>
</div>

{/* CARD 2 */}
<div className="sm:border-b sm:text-left sm:border-[#2B2E33] sm:border-r-0 md:border-r lg:border-r xl:border-r border-r border-[#2B2E33] p-8 xl:p-6 lg:p-6 md:p-5 sm:p-0">
  <div className="mb-6 flex sm:justify-center">
    <img src={VFBr_2} alt="Feature Icon 2" className="w-12 h-12 lg:w-10 lg:h-10 sm:w-8 sm:h-8" />
  </div>
  <div className="mb-4">
    <h3 className="font-[Norwester] font-[400] text-white text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] sm:text-[15px] mb-4 uppercase leading-tight">
      Enrich Your Marketing Campaigns With Real Voices
    </h3>
  </div>
  <div>
    <p className="font-[Inter] font-[400] text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] leading-relaxed sm:mb-3">
      Consumers trust real people more than polished adverts. Vupop
      helps brands enrich campaigns with genuine fan content that feels
      honest and natural. Instead of scripted endorsements, brands can
      feature:
      <ul className="list-disc list-inside mt-2">
        <li>Real customer reactions</li>
        <li>Community moments</li>
        <li>Product experiences</li>
        <li>Event highlights</li>
        <li>Celebration content</li>
        <li>Everyday usage stories</li>
      </ul>
      <p className="mt-4">
        This creates deeper engagement and stronger emotional connection
      </p>
    </p>
  </div>
</div>

{/* CARD 3 */}
<div className="sm:border-b sm:text-left sm:border-r-0 md:border-r border-[#2B2E33] p-8 xl:p-6 lg:p-6 md:p-5 sm:p-0">
  <div className="mb-6 flex sm:justify-center">
    <img src={VFBr_3} alt="Feature Icon 3" className="w-12 h-12 lg:w-10 lg:h-10 sm:w-8 sm:h-8" />
  </div>
  <div className="mb-4">
    <h3 className="font-[Norwester] font-[400] text-white text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] sm:text-[15px] mb-4 uppercase leading-tight">
      Activate During Live Moments and Beyond
    </h3>
  </div>
  <div>
    <p className="font-[Inter] font-[400] text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] leading-relaxed sm:mb-3">
      Sport remains one of the most powerful environments for fan
      engagement. However, activation does not have to stop there.
      <br />
      Brands can use Vupop to activate:
      <ul className="list-disc list-inside mt-2">
        <li>Major sports events</li>
        <li>Product launches</li>
        <li>Influencer collaborations</li>
        <li>Seasonal promotions</li>
        <li>Brand milestones</li>
        <li>Community campaigns</li>
        <li>Retail experiences</li>
        <li>Sponsorship activations</li>
      </ul>
      <p className="mt-4">
        Vupop supports campaigns wherever fans gather and engage.
      </p>
    </p>
  </div>
</div>

{/* CARD 4 */}
<div className="sm:border-b sm:text-left sm:border-[#2B2E33] sm:border-r-0 md:border-r lg:border-r xl:border-r border-r border-[#2B2E33] p-8 xl:p-6 lg:p-6 md:p-5 sm:p-0">
  <div className="mb-6 flex sm:justify-center">
    <img src={VFBr_4} alt="Feature Icon 4" className="w-12 h-12 lg:w-10 lg:h-10 sm:w-8 sm:h-8" />
  </div>
  <div className="mb-4">
    <h3 className="font-[Norwester] font-[400] text-white text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] sm:text-[15px] mb-4 uppercase leading-tight">
      Reward Fans for Their Participation
    </h3>
  </div>
  <div>
    <p className="font-[Inter] font-[400] text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] leading-relaxed sm:mb-3">
      Fans give their time, energy and loyalty to brands they believe in. Vupop enables brands to reward fans for sharing content and contributing to campaigns.
      Rewards strengthen loyalty and build long term relationships. When fans feel valued, they become brand advocates.
      <br />
      This transforms passive audiences into active communities.
    </p>
  </div>
</div>

{/* CARD 5 */}
<div className="sm:border-b sm:text-left sm:border-r-0 md:border-r lg:border-r xl:border-r border-r border-[#2B2E33] p-8 xl:p-6 lg:p-6 md:p-5 sm:p-0">
  <div className="mb-6 flex sm:justify-center">
    <img src={VFBr_5} alt="Feature Icon 5" className="w-12 h-12 lg:w-10 lg:h-10 sm:w-8 sm:h-8" />
  </div>
  <div className="mb-4">
    <h3 className="font-[Norwester] font-[400] text-white text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] sm:text-[15px] mb-4 uppercase leading-tight">
      Engage Younger, Creator Driven Audiences
    </h3>
  </div>
  <div>
    <p className="font-[Inter] font-[400] text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] leading-relaxed sm:mb-3">
      Younger audiences expect participation. They create, share and
      react daily. Traditional advertising alone no longer drives
      connection.
      <br />
      Vupop helps brands engage this generation through:
      <ul className="list-disc list-inside mt-2">
        <li>Fan content participation</li>
        <li>Creator style storytelling</li>
        <li>Community driven campaigns</li>
        <li>Authentic reaction based marketing</li>
      </ul>
      <p className="mt-4">
        This aligns brand communication with modern digital behaviour.
      </p>
    </p>
  </div>
</div>

{/* CARD 6 */}
<div className="p-8 xl:p-6 lg:p-6 md:p-5 sm:p-0 sm:text-left">
  <div className="mb-6 flex sm:justify-center">
    <img src={VFBr_6} alt="Feature Icon 6" className="w-12 h-12 lg:w-10 lg:h-10 sm:w-8 sm:h-8" />
  </div>
  <div className="mb-4">
    <h3 className="font-[Norwester] font-[400] text-white text-[22px] xl:text-[20px] lg:text-[18px] md:text-[16px] sm:text-[15px] mb-4 uppercase leading-tight">
      Use Fan Content Across All Channels
    </h3>
  </div>
  <div>
    <p className="font-[Inter] font-[400] text-[#ADADAD] text-[16px] xl:text-[14px] lg:text-[13px] md:text-[13px] sm:text-[12px] leading-relaxed sm:mb-3">
      Fan content created through Vupop can support:
      <ul className="list-disc list-inside mt-2">
        <li>Social media campaigns</li>
        <li>Digital advertising</li>
        <li>Website storytelling</li>
        <li>Email marketing</li>
        <li>Product launches</li>
        <li>Community building</li>
        <li>Brand storytelling</li>
      </ul>
      <p className="mt-4">
        Real fan voices add depth and credibility to every channel.
      </p>
    </p>
  </div>
</div>
      </div>
    </div>
  );
}
